import { Controller } from '@hotwired/stimulus';

export default class extends Controller<HTMLElement> {
    static targets = [ 'genresContainer', 'genreItem', 'genresList' ];
    private genresItems: { item: HTMLLIElement, width: number }[];
    private lastWidth = 0;
    private gapSize = 0;

    resizeObserver = new ResizeObserver(([ entry ]) => {
        requestAnimationFrame(() => {
            const newWidth = Math.round(entry.contentRect.width);

            if (newWidth !== this.lastWidth) {
                this.lastWidth = newWidth;
                this.hideGenresItems(newWidth);
            }
        });
    });

    connect(): void {
        this.assignGenresItems();
        this.calculateGapSize();
        this.resizeObserver.observe(this.genresContainerTarget);
    }

    calculateGapSize(): void {
        if (this.genreItemTargets.length > 2) {
            const first = this.genreItemTargets[0].getBoundingClientRect();
            const second = this.genreItemTargets[1].getBoundingClientRect();

            this.gapSize = second.left - first.right;
        }
    }

    assignGenresItems(): void {
        this.genresItems = this.genreItemTargets.map((itemTarget) => {
            return { item: itemTarget, width: itemTarget.offsetWidth };
        });
    }

    hideGenresItems(containerWidth: number): void {
        let index = 0;
        let widthUsed = 0;

        const effectiveWidth = containerWidth - 1;

        for (const { width } of this.genresItems) {
            if (widthUsed + width + this.gapSize < effectiveWidth) {
                widthUsed += width + this.gapSize;
                index++;
            } else if (widthUsed + width < effectiveWidth) {
                widthUsed += width;
                index++;
            } else {
                break;
            }
        }

        const visible = this.genreItemTargets.slice(0, index);
        const hidden = this.genreItemTargets.slice(index, this.genreItemTargets.length);

        visible.forEach((item: HTMLLIElement) => item.classList.remove('hidden'));
        hidden.forEach((item: HTMLLIElement) => item.classList.add('hidden'));
    }

    disconnect(): void {
        this.resizeObserver.disconnect();
    }

    declare readonly hasGenresContainerTarget: boolean;
    declare readonly hasGenresListTarget: boolean;
    declare readonly genresContainerTarget: HTMLDivElement;
    declare readonly genresListTarget: HTMLUListElement;
    declare readonly genreItemTargets: HTMLLIElement[];
}
